module.exports = __webpack_public_path__ + "img/slide-1-placeholder.20983e27.png";